import { useState, useEffect } from 'react';
import { getServiceCommissions } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useServiceCommissions(queryParams = {}) {
  const [data, setData] = useState({
    commissions: [],
    total: 0,
    page: 1,
    pageSize: 20,
    next: null,
    previous: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommissions = async () => {
      setLoading(true);
      setError(null);

      try {
        const { commissions, total, next, previous } = await getServiceCommissions(queryParams);

        setData({
          commissions,
          total,
          page: queryParams.page ?? 1,
          pageSize: queryParams.pageSize ?? 20,
          next,
          previous,
        });
      } catch (err) {
        const errorMessage = handleApiError(err);
        setError(errorMessage);
        console.error('خطأ في جلب قائمة عمولات الخدمات:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCommissions();
  }, [queryParams]);

  return {
    commissions: data.commissions,
    total: data.total,
    page: data.page,
    pageSize: data.pageSize,
    next: data.next,
    previous: data.previous,
    loading,
    error,
    refetch: () => {
      const fetchCommissions = async () => {
        setLoading(true);
        setError(null);

        try {
          const { commissions, total, next, previous } = await getServiceCommissions(queryParams);

          setData({
            commissions,
            total,
            page: queryParams.page ?? 1,
            pageSize: queryParams.pageSize ?? 20,
            next,
            previous,
          });
        } catch (err) {
          const errorMessage = handleApiError(err);
          setError(errorMessage);
          console.error('❌ خطأ في إعادة جلب قائمة عمولات الخدمات:', err);
        } finally {
          setLoading(false);
        }
      };

      fetchCommissions();
    }
  };
}
